import React, { useMemo } from 'react';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  TimeScale,
  Filler,
} from 'chart.js';
import { Line } from 'react-chartjs-2';

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  TimeScale,
  Filler,
);

function UsageChart({ series = [], title = '' }) {
  const labels = useMemo(() => series.map(r => {
    try { return new Date(r.bucket).toLocaleString(); } catch { return String(r.bucket); }
  }), [series]);
  const data = useMemo(() => series.map(r => Number(r.count) || 0), [series]);

  const chartData = useMemo(() => ({
    labels,
    datasets: [
      {
        label: 'Chats per week',
        data,
        borderColor: 'rgb(13,110,253)',
        backgroundColor: 'rgba(13,110,253,0.2)',
        tension: 0.25,
        pointRadius: 3,
        fill: true,
      },
    ],
  }), [labels, data]);

  const options = useMemo(() => ({
    responsive: true,
    plugins: {
      legend: { display: false },
      title: { display: !!title, text: title },
      tooltip: { intersect: false, mode: 'index' },
    },
    scales: {
      x: {
        title: { display: !!title, text: '' },
        grid: { display: false },
      },
      y: {
        title: { display: true, text: 'Chats' },
        beginAtZero: true,
        ticks: { precision: 0 },
      },
    },
  }), [title]);

  return <Line data={chartData} options={options} />;
}

export default UsageChart;
